import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50 flex flex-col items-center justify-center text-center px-4 relative overflow-hidden">
      <span className="absolute inset-0 flex items-center justify-center text-[12rem] md:text-[18rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </span>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold text-foreground-950 mt-6">This page has not been generated</h1>
        <p className="mt-2 text-base text-foreground-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-foreground-500">Tell me more about this page, so I can generate it</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 mt-8 px-6 py-3 rounded-full bg-foreground-950 text-background-50 text-sm font-semibold cursor-pointer hover:bg-foreground-800 transition-all whitespace-nowrap"
        >
          Back to Home
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </div>
  );
}